// src/pages/profile-settings/screens/ProfilePage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import TopBar from "@/sot/primitives/TopBar.jsx";
import SettingsProfile from "@/pages/profile-settings/patient/SettingsProfile.jsx";
import SettingsScreenShell from "@/sot/layouts/SettingsScreenShell.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";
import { PATIENT_SETTINGS_HOME_ROUTE } from "@/pages/profile-settings/settingsNavigation.js";

export default function ProfilePage() {
  const nav = useNavigate();
  const { t } = useLanguage();

  return (
    <SettingsScreenShell>
      <TopBar
        title={t("settings.profile.title", "Profile")}
        onBack={() => nav(PATIENT_SETTINGS_HOME_ROUTE)}
      />
      <div className="mt-4">
        <SettingsProfile />
      </div>
    </SettingsScreenShell>
  );
}
